import { render } from "./BlockOthers.vue?vue&type=template&id=545bfba7"
import script from "./BlockOthers.vue?vue&type=script&lang=js"
export * from "./BlockOthers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__